export default __webpack_public_path__ + "static/media/012_photo.8764d8b0.jpg";